// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3503":"31420fc2","3752":"77ab36e7","5975":"31420fc2","6814":"31420fc2"}[chunkId] + ".chunk.css";
};